'use strict';
/* global fetch */

var baseUrl = 'https://min-api.cryptocompare.com/data/';
var apiKey = '';

function setApiKey(userApiKey) {
  apiKey = userApiKey;
}

function fetchJSON(url) {
  if (apiKey !== '') {
    if (url.indexOf('?') > -1) {
      url += '&api_key=';
    } else {
      url += '?api_key=';
    }

    url += apiKey;
  }

  return fetch(url).then(function (res) {
    if (!res.ok) {
      throw new Error("".concat(res.status, " ").concat(res.statusText));
    }

    return res.json();
  }).then(function (body) {
    if (body.Response === 'Error') throw body.Message;
    return body;
  });
}

function coinList() {
  var url = "".concat(baseUrl, "all/coinlist");
  return fetchJSON(url);
}

function exchangeList() {
  var url = "".concat(baseUrl, "all/exchanges");
  return fetchJSON(url);
}

function newsFeedsAndCategories() {
  var url = "".concat(baseUrl, "data/news/feedsandcategories");
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function newsList(lang, options) {
  options = options || {};
  var url = "".concat(baseUrl, "data/v2/news/?lang=").concat(lang);
  if (options.feeds) url += "&feeds=".concat(options.feeds);
  if (options.categories) url += "&categories=".concat(options.categories);
  if (options.excludeCategories) url += "&categories=".concat(options.excludeCategories);

  if (options.lTs) {
    options.lTs = dateToTimestamp(options.lTs);
    url += "&lTs=".concat(options.lTs);
  }

  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function price(fsym, tsyms, options) {
  options = options || {};
  var url = "".concat(baseUrl, "price?fsym=").concat(fsym, "&tsyms=").concat(tsyms);
  if (options.exchanges) url += "&e=".concat(options.exchanges);
  if (options.tryConversion === false) url += '&tryConversion=false';
  return fetchJSON(url);
}

function priceMulti(fsyms, tsyms, options) {
  options = options || {};
  var url = "".concat(baseUrl, "pricemulti?fsyms=").concat(fsyms, "&tsyms=").concat(tsyms);
  if (options.exchanges) url += "&e=".concat(options.exchanges);
  if (options.tryConversion === false) url += '&tryConversion=false';
  return fetchJSON(url);
}

function priceFull(fsyms, tsyms, options) {
  options = options || {};
  var url = "".concat(baseUrl, "pricemultifull?fsyms=").concat(fsyms, "&tsyms=").concat(tsyms);
  if (options.exchanges) url += "&e=".concat(options.exchanges);
  if (options.tryConversion === false) url += '&tryConversion=false'; // We want the RAW data, not the DISPLAY data:

  return fetchJSON(url).then(function (result) {
    return result.RAW;
  });
}

function priceHistorical(fsym, tsyms, time, options) {
  options = options || {};
  time = dateToTimestamp(time);
  var url = "".concat(baseUrl, "pricehistorical?fsym=").concat(fsym, "&tsyms=").concat(tsyms, "&ts=").concat(time);
  if (options.exchanges) url += "&e=".concat(options.exchanges);
  if (options.tryConversion === false) url += '&tryConversion=false'; // The API returns json with an extra layer of nesting, so remove it

  return fetchJSON(url).then(function (result) {
    return result[fsym];
  });
}

function generateAvg(fsym, tsym, e, tryConversion) {
  var url = "".concat(baseUrl, "generateAvg?fsym=").concat(fsym, "&tsym=").concat(tsym, "&e=").concat(e);
  if (tryConversion === false) url += '&tryConversion=false';
  return fetchJSON(url).then(function (result) {
    return result.RAW;
  });
}

function topPairs(fsym, limit) {
  var url = "".concat(baseUrl, "top/pairs?fsym=").concat(fsym);
  if (limit) url += "&limit=".concat(limit);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function topExchanges(fsym, tsym, limit) {
  var url = "".concat(baseUrl, "top/exchanges?fsym=").concat(fsym, "&tsym=").concat(tsym);
  if (limit) url += "&limit=".concat(limit);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function topExchangesFull(fsym, tsym, limit) {
  var url = "".concat(baseUrl, "top/exchanges/full?fsym=").concat(fsym, "&tsym=").concat(tsym);
  if (limit) url += "&limit=".concat(limit);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function histoDay(fsym, tsym, options) {
  options = options || {};
  if (options.timestamp) options.timestamp = dateToTimestamp(options.timestamp);
  var url = "".concat(baseUrl, "histoday?fsym=").concat(fsym, "&tsym=").concat(tsym);
  if (options.exchange) url += "&e=".concat(options.exchange);
  if (options.limit === 'none') url += '&allData=true';else if (options.limit) url += "&limit=".concat(options.limit);
  if (options.tryConversion === false) url += '&tryConversion=false';
  if (options.aggregate) url += "&aggregate=".concat(options.aggregate);
  if (options.timestamp) url += "&toTs=".concat(options.timestamp);
  if (options.aggregatePredictableTimePeriods) url += "&aggregatePredictableTimePeriods=".concat(options.aggregatePredictableTimePeriods);
  if (options.allData) url += "&allData=".concat(options.allData);
  if (options.toTs) url += "&toTs=".concat(options.toTs);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function histoHour(fsym, tsym, options) {
  options = options || {};
  if (options.timestamp) options.timestamp = dateToTimestamp(options.timestamp);
  var url = "".concat(baseUrl, "histohour?fsym=").concat(fsym, "&tsym=").concat(tsym);
  if (options.exchange) url += "&e=".concat(options.exchange);
  if (options.limit) url += "&limit=".concat(options.limit);
  if (options.tryConversion === false) url += '&tryConversion=false';
  if (options.aggregate) url += "&aggregate=".concat(options.aggregate);
  if (options.timestamp) url += "&toTs=".concat(options.timestamp);
  if (options.allData) url += "&allData=".concat(options.allData);
  if (options.toTs) url += "&toTs=".concat(options.toTs);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function histoMinute(fsym, tsym, options) {
  options = options || {};
  if (options.timestamp) options.timestamp = dateToTimestamp(options.timestamp);
  var url = "".concat(baseUrl, "histominute?fsym=").concat(fsym, "&tsym=").concat(tsym);
  if (options.exchange) url += "&e=".concat(options.exchange);
  if (options.limit) url += "&limit=".concat(options.limit);
  if (options.tryConversion === false) url += '&tryConversion=false';
  if (options.aggregate) url += "&aggregate=".concat(options.aggregate);
  if (options.timestamp) url += "&toTs=".concat(options.timestamp);
  if (options.allData) url += "&allData=".concat(options.allData);
  if (options.toTs) url += "&toTs=".concat(options.toTs);
  return fetchJSON(url).then(function (result) {
    return result.Data;
  });
}

function dateToTimestamp(date) {
  if (!(date instanceof Date)) throw new Error('timestamp must be an instance of Date.');
  return Math.floor(date.getTime() / 1000);
}

module.exports = {
  setApiKey: setApiKey,
  coinList: coinList,
  exchangeList: exchangeList,
  newsFeedsAndCategories: newsFeedsAndCategories,
  newsList: newsList,
  price: price,
  priceMulti: priceMulti,
  priceFull: priceFull,
  priceHistorical: priceHistorical,
  generateAvg: generateAvg,
  topPairs: topPairs,
  topExchanges: topExchanges,
  topExchangesFull: topExchangesFull,
  histoDay: histoDay,
  histoHour: histoHour,
  histoMinute: histoMinute
};